import React, { useCallback, useEffect, useState } from 'react';
import { debounce } from '@mui/material';

import Search from 'src/components/search/Search';
import { useLeadsPageContext } from 'src/pages/landlord/leads/provider';
import { analyticsClient } from 'src/services/analytics';
import { AnalyticsEvent } from 'src/services/analytics/events';

export default function LeadsSearch() {
    const [value, setValue] = useState('');
    const [isSearching, setSearching] = useState(false);

    const { search, setSearch } = useLeadsPageContext();

    const trackSearch = useCallback(debounce((query: string) => {
        if (query) {
            analyticsClient.track(AnalyticsEvent.LEADS_SEARCHED, { query });
        }
    }, 300), []);

    const setSearchQueryDebounced = useCallback(debounce(setSearch, 300), []);

    useEffect(() => {
        setSearchQueryDebounced(value);
        trackSearch(value);
    }, [value, setSearchQueryDebounced, trackSearch]);

    useEffect(() => {
        if (value !== search) {
            setSearching(true);
        } else {
            setSearching(false);
        }
    }, [value, search]);

    return (
        <Search
            type="search"
            placeholder="Search leads..."
            helperText="Search by name, email, phone, property, stage, notes."
            value={value}
            onChange={setValue}
            size="small"
            fullWidth
            isLoading={isSearching}
            data-testid="leads-search-field"
        />
    );
}
